<section>
    <span c-activity-log-blurb activity="activity"></span>{{'changeOwnerLog.to'|translate}}
    <span class="tag">{{activity.Owner.DisplayName}}&nbsp;({{activity.Owner.UserName}})</span>
    <div c-activity-log-message activity="activity"></div>
</section>